import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import z from 'zod/v4';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

const deleteTaskVariablesSchema = z.object({
  id: z.string(),
});

export type DeleteMailVariables = z.infer<typeof deleteTaskVariablesSchema>;

export async function deleteMailFn(
  axiosInstance: Promise<AxiosInstance>,
  data: DeleteMailVariables,
) {
  const instance = await axiosInstance;
  return instance.delete(`mails/threads/${data.id}`);
}

export function useDeleteMail() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, DeleteMailVariables>({
    mutationFn: variables => deleteMailFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['mails'] });
    },
  });

  return addActionNameToMutationResult<ApiResponse, ApiError, DeleteMailVariables, 'deleteMail'>(
    'deleteMail',
    mutation,
  );
}
